import Link from 'next/link';
import React from 'react';

const BuildFutureFarming = () => {
    return (
        <div className="pt-100">
            <div className="container lg:container md:mx-auto">
                <div className="row grid lg:grid-cols-12 mb-50">
                    <div className="lg:col-span-12">
                        <h2 className="text-primary_one mb-3" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            Build the Future of Farming—One Line of Code at a Time
                        </h2>
                        <p className="mb-3" data-aos="fade-up" data-aos-duration="700" data-aos-delay="200">
                            From field to forecast, Moweb Technologies builds secure, scalable agriculture software solutions that
                            help you grow smarter, not harder.
                        </p>
                        <div>
                            <Link
                                href="/contact-us"
                                className="btn btn-primary bg-[#00B050] border-[#00B050] hover:border-[#00B050]"
                            >
                                {'Start Your AgTech Journey'}
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default BuildFutureFarming;
